<script setup lang="ts">
  import { computed } from 'vue'
  import AppChart from '@/components/app-chart.vue'

  const props = defineProps<{
    title: string,
    data: RevenueStats[],
  }>()

  const chartData = computed(() => props.data.map((d) => d.value))

  const chartCategories = computed(() => {
    return props.data.map((d) => d.group)
  })

  const chartOptions = computed(() => {
    return {
      chart: {
        type: 'line',
        style: {
          fontFamily: 'inherit',
        },
      },
      title: {
        text: props.title,
        style: {
          fontSize: '18px',
          fontWeight: '600',
        },
      },
      yAxis: {
        title: { text: '' },
        gridLineColor: '#f0f0f0',
      },
      xAxis: {
        categories: chartCategories.value,
        lineColor: '#e0e0e0',
        tickColor: '#e0e0e0',
      },
      plotOptions: {
        line: {
          marker: {
            enabled: true,
            radius: 4,
            symbol: 'circle',
          },
          lineWidth: 2,
        },
      },
      colors: ['#3b82f6'],
      series: [{ data: chartData.value, name: 'Omset' }],
      credits: { enabled: false },
    } as Highcharts.Options
  })
</script>

<template>
  <app-chart
    constructor-type="chart"
    :options="chartOptions" />
</template>
